import { AxiosResponse } from "axios";
import { fork, put, takeLatest } from "redux-saga/effects";
import { RxAlertList } from "../../Apis/AuthApiServices";
import {
  loadingRxAlertsDetails,
  setRxAlertsDetails,
} from "../Slice/RxAlertsDetailsSlice";

function* onLoadRxAlertsDetailsAsync({ payload }: any) {
  const params = new URLSearchParams();
  const doctorId: any = localStorage.getItem("doctorId");
  params.append("doctorId", doctorId);
  params.append("pageNumber", payload.pageNumber);
  params.append("pageSize", payload.pageSize);
  params.append("selectedDoctorId", payload.selectedDoctorId);
  try {
    const result: AxiosResponse = yield RxAlertList(params);
    if (result?.data?.digitalRxStatusCode === 200) {
      yield put(
        setRxAlertsDetails({
          RxAlertsDetailsData: result?.data?.response,
          Items: result?.data?.response[0]?.items,
          Pagination: result?.data?.response[0]?.pagination,
          isLoading: false,
          error: false,
        })
      );
    } else {
      yield put(
        setRxAlertsDetails({
          RxAlertsDetailsData: [],
          error: false,
          isLoading: false,
          message: result?.data?.digitalRxStatusMessage,
        })
      );
    }
  } catch (error: any) {
    yield put(
      setRxAlertsDetails({
        RxAlertsDetailsData: [],
        error: true,
        isLoading: false,
        message: "Try Again After Some Time!",
      })
    );
  }
}

function* onLoadRxAlertsDetails() {
  yield takeLatest(loadingRxAlertsDetails.type, onLoadRxAlertsDetailsAsync);
}

const RxAlertsDetailsSaga = [fork(onLoadRxAlertsDetails)];
export default RxAlertsDetailsSaga;
